import { render, staticRenderFns } from "./select-box.vue?vue&type=template&id=6cb14a8a&scoped=true"
import script from "./select-box.vue?vue&type=script&lang=js"
export * from "./select-box.vue?vue&type=script&lang=js"
import style0 from "./select-box.vue?vue&type=style&index=0&id=6cb14a8a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb14a8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb14a8a')) {
      api.createRecord('6cb14a8a', component.options)
    } else {
      api.reload('6cb14a8a', component.options)
    }
    module.hot.accept("./select-box.vue?vue&type=template&id=6cb14a8a&scoped=true", function () {
      api.rerender('6cb14a8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/select-box.vue"
export default component.exports